<template>
  <section class="well should-you-call-long-run-disclaimer">
    <header>
      <h1 class="page-header">The long run</h1>
    </header>
    <p>Even after factoring in what might happen on future streets, there are still longer run game dynamic type things to consider, such as:</p>
    <ul>
      <li>Calling to gather information about your opponent.</li>
      <li>Calling to establish a certain table image.</li>
      <li>Calling to put your opponent on tilt.</li>
    </ul>
    <p>Maybe the call is profitable in the long run for one of the reasons listed above, even if it isn't profitable right now.</p>
    <p>Factoring in these sorts of things is beyond the scope of Six Plus Hold’em right now, but perhaps there will be tools to do so in the future.</p>
  </section>
</template>

<script>
export default {
  name: 'should-you-call-long-run-disclaimer',
};
</script>

<style lang="scss" scoped>
  .should-you-call-long-run-disclaimer {
    font-size: 18px;

    h1, h3, li, p, table {
      max-width: 800px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-call/conclusions/long-run-disclaimer.vue